import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faChartPie, faFileInvoiceDollar, faReceipt, faMagnifyingGlassChart, faUserTie } from '@fortawesome/free-solid-svg-icons';
import './Services.css';

const servicesData = [
    {
        icon: faBook,
        title: 'Professional Bookkeeping',
        description: 'We help you establish and maintain accurate financial accounts, overall financial processes and management through our exceptional bookkeeping services in UAE.',
        link: '/bookkeeping'
    },
    {
        icon: faChartPie,
        title: 'Corporate Tax',
        description: 'We act as your mentor and advice you on the corporate tax matters to ensure absolute compliance with the new regulations. We help simplify the processes, rules, and requirements for implementing corporate tax in UAE.',
        link: '/corporatetax'
    },
    {
        icon: faFileInvoiceDollar,
        title: 'Audit',
        description: 'We help you in achieving compliance with various laws and regulations by reviewing the accuracy of financial statement and records.',
        link: '/audit'
    },
    {
        icon: faReceipt,
        title: 'VAT Consulting',
        description: 'We ensure that your books of accounts and records are as per relevant VAT laws and advise you regarding optimizing your VAT position. We give you a practical approach about VAT obligations.',
        link: '/vatconsult' 
    },
    {
        icon: faMagnifyingGlassChart,
        title: 'Internal Audit',
        description: 'We help you evaluate your internal controls, including corporate governance and accounting processes with a view to add value and improve organization’s operations.',
        link: '/internalaudit'
    },
    {
        icon: faUserTie,
        title: 'Tax Agent',
        description: 'We help you navigate the complex world of taxes. We assist you with your tax obligations and represent you before tax authority in any tax-related matters.',
        link: '/taxagents'
    },
];

const Services = () => {
    return (
        <section id="services" className="services-section">
            <div className="container">
                <h2 className="section-title">Our Services</h2>
                <div className="services-grid">
                    {servicesData.map((service, index) => (
                        <div className="service-card" key={index}>
                            <div className="card-content">
                                <FontAwesomeIcon icon={service.icon} className="service-icon" />
                                <h5 className="service-title">{service.title}</h5>
                                <p className="service-description">{service.description}</p>
                                <a href={service.link} className="details-btn">Details</a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;